// Color tags for coaches. Each coach carries a `color` used for their avatar
// chip in the Coaches tab and (subtly) wherever a group shows its coach, so a
// pro is identifiable at a glance. Values are picked to read well as a solid
// background under white text and to stay distinct from the tier colors used
// on the schedule grid.
export const COACH_COLORS = [
  "#2563eb", // blue
  "#0d9488", // teal
  "#7c3aed", // violet
  "#db2777", // pink
  "#ea580c", // orange
  "#4d7c0f", // olive
  "#0891b2", // cyan
  "#be123c", // rose
];

// Deterministic default so a new coach lands on a color that isn't already
// obviously in use — keyed off the current coach count.
export function defaultCoachColor(index) {
  return COACH_COLORS[index % COACH_COLORS.length];
}

// "Sarah Chen" -> "Sarah C", "Mike" -> "Mike", "" -> ""
export function coachShortName(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1][0]}`;
}

// "Sarah Chen" -> "SC", "Mike" -> "MI", "" -> "?"
export function coachInitials(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
